<template>
  <div class="main-footer">
    <template v-if="footer_style === 'original'">
      <div class="custom-footer">
        <img class="logo" src="../assets/images/logo-footer.png" alt="" />
        <img
          src="../assets/images/thin-line.png"
          style="width: 1px; height: 127px"
        />
        <div class="info">
          <div class="slogan">衣创社区——让灵感点亮世界，让创意成就品牌。</div>
          <div class="phone">服务热线：<span>{{ setting.service_phone }}</span></div>
          <div class="copyright">COPYRIGHT@2026 衣创社区 版权所有 
            <a class="icp-link" target="_blank" href="https://beian.miit.gov.cn">闽ICP备20099176号-1</a>, 
            <a class="icp-link" target="_blank" href="https://beian.miit.gov.cn">闽ICP备20099176号-12</a>, 
            <a class="icp-link" target="_blank" href="https://beian.miit.gov.cn">闽ICP备202604756号-5</a>, 
            <a class="icp-link" target="_blank" href="https://beian.miit.gov.cn">闽ICP备202604756号-3</a>
          </div>
          <div class="menu">
            <!-- <span class="menu-item" @click="$router.push({ name: 'Login' })">关于衣创社区</span>
            <span class="menu-divider">|</span> -->
            <span class="menu-item" @click="$router.push({name:'BusinessCooperation'})">商务合作</span>
            <span class="menu-divider">|</span>
            <span class="menu-item" @click="showChat">帮助与客服</span>
            <span class="menu-divider">|</span>
            <span class="menu-item" @click="$router.push({name:'UserAppeal'})">侵权申诉</span>
            <span class="menu-divider">|</span>
            <span class="menu-item" @click="go2">版师入驻</span>
          </div>
          <div v-if="showSupply" class="support">技术支持：福建海邻网络科技有限公司</div>
        </div>
        <img class="qrcode" src="../assets/images/qrcode.jpg" alt="" />
      </div>
    </template>
    <template v-if="footer_style === 'mall'">
      <div class="mall-footer">
        <div class="link-box">
          <div class="logo-slogan">
            <div class="logo">
              <img src="../assets/images/logo-footer.png" alt="" />
            </div>
            <div class="slogan">专注于高端设计师定制服装,为追求品质与个性的您提供独一无二的穿着体验。</div>
          </div>
          <div class="line"></div>
          <div class="link-list">
            <div class="link-list-title">快速链接</div>
            <div class="link-list-item-box">
              <div class="list-item-box-wraper">
                <div v-for="(item,index) in quick_link_1" :key="`col-1-${index}`" class="list-item" @click="$router.push({path:item.url})">{{item.title}}</div>
              </div>
              <div class="list-item-box-wraper">
                <div v-for="(item,index) in quick_link_2" :key="`col-2-${index}`" class="list-item" @click="$router.push({path:item.url})">{{item.title}}</div>
              </div>
              <div class="list-item-box-wraper">
                <div v-for="(item,index) in quick_link_3" :key="`col-3-${index}`" class="list-item" @click="$router.push({path:item.url})">{{item.title}}</div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="link-list">
            <div class="link-list-title">客户服务</div>
            <div class="link-list-item-box">
              <div class="list-item-box-wraper">
                <div class="list-item" v-for="(item,index) in list" :key="index" @click="$router.push({name:'CustomService',query:{id:item.id}})">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="qrcode-box">
          <div class="qrcode-img">
            <img src="../assets/images/qrcode.jpg" alt="" />
          </div>
          <span>微信扫一扫</span>
          <span>即可浏览手机端</span>
        </div>
        <div class="icp-author">
          <div class="icp-wrapper">
            <a
              href="https://beian.miit.gov.cn"
              target="_blank"
              class="icp"
              >
              {{ setting.icp }}</a
            > <template v-if="showSupply"> | <div class="author-support">技术支持：福建海邻网络科技有限公司</div></template>

          </div>
        </div>
      </div>
    </template>
    <template v-if="footer_style !== 'original' && footer_style !== 'mall'">
      <div :class="footer_style === 'light' ? 'light-footer' : 'dark-footer'">
        <div class="left-box">
          <div class="left-box-item" @click="$router.push({ name: 'Login' })">
            关于衣创社区
          </div>
          <div class="left-box-item left-border" @click="$router.push({name:'BusinessCooperation'})">商务合作</div>
          <div class="left-box-item left-border" @click="showChat">帮助与客服</div>
          <div class="left-box-item left-border" @click="$router.push({name:'UserAppeal'})">侵权申诉</div>
          <div class="left-box-item left-border" @click="go2">版师入驻</div>
          <div class="footer-phone"></div>
        </div>
        <div class="right-box">
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            class="icp right-box-item"
            >
            {{ setting.icp }}</a
          >
          <div v-if="showSupply" class="right-box-item right-border">
            技术支持:福建海邻网络科技有限公司
          </div>
        </div>
      </div>
    </template>
    <chat ref="chat"></chat>
  </div>
</template>

<script>
import { GetCustomerServiceList } from '@/api/index';
import { mapState } from "vuex";
export default {
  name: "Footer",
  props: {
    footer_style: {
      type: String,
      default: "light",
    },
  },
  data(){
    return {
      list:[],
      showSupply:false
    }
  },
  watch:{
    footer_style(news,olds){
      if(news === 'mall'){
        this.getCustomerServiceList();
      }
    }
  },
  computed: {
    ...mapState(["setting"]),
    quick_link_1(){
      if(this.setting && this.setting.quick_link && this.setting.quick_link.col_1 && this.setting.quick_link.col_1.length>0){
        return this.setting.quick_link.col_1;
      }
      return [];
    },
    quick_link_2(){
      if(this.setting && this.setting.quick_link && this.setting.quick_link.col_2 && this.setting.quick_link.col_2.length>0){
        return this.setting.quick_link.col_2;
      }
      return [];
    },
    quick_link_3(){
      if(this.setting && this.setting.quick_link && this.setting.quick_link.col_3 && this.setting.quick_link.col_3.length>0){
        return this.setting.quick_link.col_3;
      }
      return [];
    }
  },
  mounted(){

  },
  methods: {
    go2() {
      location.href='/patternMakerRegister'
    },
    async getCustomerServiceList(){
        const {code,msg,data} = await GetCustomerServiceList();
        if(code>0){
            this.$layer.msg(msg);
            return;
        }
        console.log('data',data);
        this.list = data || [];
    },
    showChat() {
				this.$refs["chat"].showChat();
			},
    goBack() {
      this.$router.back();
    },
    go(url) {
      if (url.startsWith("http")) {
        window.open(url, "_blank");
        return;
      }
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-footer {
  display: flex;
  justify-content:center;
  position:relative;
  .dark-footer {
    background: #1f1f1f;
    width: 100%;
    max-width: 1920px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #1f1f1f;
    padding: 0 60px;
    color: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    overflow: hidden;
    .left-box {
      display: flex;
      justify-content: start;
      align-items: center;
      height: 100%;
      flex: 1;
      .left-box-item {
        // flex:0 0 calc(100% / 4);
        width:fit-content;
        min-width:0;
        max-width:25%;
        padding-right: 20px;
        cursor: pointer;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
      }
      .left-border {
        padding-left: 20px;
        border-left: 1px solid #ffffff;
      }
      .footer-phone {
        background-image: url(../assets/images/icon-phone-footer-white.png);
        background-size: cover;
        background-repeat: no-repeat;
        width: 17px;
        height: 17px;
      }
    }
    .right-box {
      display: flex;
      justify-content: end;
      align-items: center;
      flex: 1;
      height: 100%;
      .right-box-item {
        padding-right: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .right-border {
        padding-left: 20px;
        border-left: 1px solid #ffffff;
      }
      .icp {
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  .light-footer {
    background: #fff;
    width: 100%;
    // max-width:1920px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e8e8eb;
    padding: 0 60px;
    color: #808080;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    overflow: hidden;
    .left-box {
      display: flex;
      justify-content: start;
      align-items: center;
      height: 100%;
      flex: 1;
      .left-box-item {
        padding-right: 20px;
        cursor: pointer;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
        // flex:0 0 20%;
        width:fit-content;
        min-width:0;
        max-width:25%;
      }
      .left-border {
        padding-left: 20px;
        border-left: 1px solid #808080;
      }
      .footer-phone {
        background-image: url(../assets/images/icon-phone-footer.png);
        background-size: cover;
        background-repeat: no-repeat;
        width: 17px;
        height: 17px;
      }
    }
    .right-box {
      display: flex;
      justify-content: end;
      align-items: center;
      flex: 1;
      height: 100%;
      white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      .right-box-item {
        padding-right: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .right-border {
        padding-left: 20px;
        border-left: 1px solid #808080;
      }
      .icp {
        color: #808080;
        font-size: 14px;
      }
    }
  }

  .custom-footer {
    height: 210px;
    width: 100%;
    max-width: 1920px;
    padding: 0 293px;
    background: #1f1f1f;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .logo {
      width: 190px;
      height: 60px;
      margin-right: 40px;
    }

    .info {
      width: 930px;
      color: #b3b3b3;
      padding-left: 40px;
      // border-left: 1px solid #ccc;
      .slogan {
        font-size: 20px;
        color: #ffffff;
      }
      .phone {
        margin-top:16px;
        margin-bottom: 24px;
        font-size: 16px;
        font-weight: bold;
        display:flex;
        align-items:center;
        span{
          font-size:20px;
          color:#b3b3b3;
        }
      }
      .copyright {
        font-size: 12px;
        color: #b3b3b3;
        margin-bottom: 24px;
        .icp-link {
          color: #b3b3b3;
          text-decoration: none;
          &:hover {
            color: #ffffff;
          }
        }
      }
      .menu {
        font-size: 14px;
        color: #b3b3b3;
        .menu-item {
          cursor: pointer;
          &:hover {
            color: #ffffff;
          }
        }
        .menu-divider {
          margin: 0 8px;
          color: #b3b3b3;
        }
      }
      .support {
        font-size: 14px;
        margin-bottom: 6px;
      }
      .icp {
        color: #b3b3b3;
        font-size: 14px;
      }
    }
    .qrcode {
      width: 110px;
      height: 110px;
    }
  }

  .mall-footer{
    background:#1f1f1f;
    width:100%;
    display:flex;
    // align-items:center;
    justify-content:center;
    // column-gap:200px;
    padding-top:58px;
    flex-wrap:wrap;
    .link-box{
      display:flex;
      column-gap:58px;
      margin-right:200px;
      .logo-slogan{
        display:flex;
        flex-direction:column;
        row-gap:28px;
        width:auto;
        max-width:322px;
        .logo{
          width:auto;
          max-width:172px;
          height:49px;
          img{
            width:100%;
            height:100%;
          }
        }
        .slogan{
          color:#cccccc;
          font-size:14px;
        }
      }
      .line{
        width:1px;
        height:210px;
        background:rgba(255,255,255,0.1);
        margin-bottom:76px;
      }
      .link-list{
        display:flex;
        flex-direction:column;
        .link-list-title{
          color:#ffffff;
          font-size:18px;
          font-weight:500;
          line-height:34px;
        }
        .link-list-item-box{
          display:flex;
          column-gap:40px;
          .list-item-box-wraper{
            display:flex;
            flex-direction:column;
            .list-item{
              color:#cccccc;
              font-size:14px;
              line-height:34px;
              cursor:pointer;
              &:hover{
                color:#ffffff;
                border-bottom:1px solid #ffffff;
              }
            }
          }
        }
      }
    }
    .qrcode-box{
      display:flex;
      flex-direction:column;
      align-items:center;
      // height:100%;
      margin-top:16px;
      // justify-content:center;
      .qrcode-img{
        width:120px;
        height:120px;
        margin-bottom:22px;
        img{
          width:100%;
          height:100%;
        }
      }
      span{
        color:#ffffff;
        font-size:14px;
        line-height:22px;
      }
    }
    .icp-author{
      width:100%;
      padding:0 100px;
      .icp-wrapper{
        border-top:1px solid #363636;
        display:flex;
        width:100%;
        padding:30px 0;
        align-items:center;
        justify-content:center;
        color:#cccccc;
        a{
          color:#cccccc;
          margin-right:10px;
        }
        .author-support{
          margin-left:10px;
        }
      }
    }
  }
}

@media (max-width: 1279px) {
  .main-footer {
    display: block;
    width: auto;
    min-width:1000px;
    max-width: 1279px;
    // overflow:hidden;
    // overflow-x:hidden;
    .dark-footer {
      width: 100%;
      max-width: 1279px;
      height: 45px;
      padding: 0 60px;
      bottom: 0;
      left: 0;
      right: 0;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 20px;
        }
        .left-border {
          padding-left: 20px;
        }
        .footer-phone {
          width: 17px;
          height: 17px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 20px;
        }
        .right-border {
          padding-left: 20px;
        }
        .icp {
          color: #ffffff;
          font-size: 14px;
        }
      }
    }

    .light-footer {
      width: 100%;
      max-width: 1279px;
      height: 45px;
      padding: 0 48px;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 16px;
        }
        .left-border {
          padding-left: 16px;
        }
        .footer-phone {
          width: 13.6px;
          height: 13.6px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 16px;
        }
        .right-border {
          padding-left: 16px;
        }
        .icp {
          font-size: 12px;
        }
      }
    }

    .custom-footer {
      height: 210px;
      width: 1279px;
      max-width: 1279px;
      padding: 0 134.4px;

      .logo {
        width: 152px;
        height: 48px;
        margin-right: 32px;
      }

      .info {
        width: 930px;
        padding-left: 40px;
        .slogan {
          font-size: 20px;
        }
        .phone {
          margin-bottom: 24px;
          font-size: 16px;
        }
        .support {
          font-size: 14px;
          margin-bottom: 6px;
        }
        .icp {
          font-size: 14px;
        }
      }
      .qrcode {
        width: 110px;
        height: 110px;
      }
    }
  }
}
@media (min-width: 1280px) and (max-width: 1679px) {
  .main-footer {
    width: auto;
    min-width: 1280px;
    max-width: 1679px;
    .dark-footer {
      width: 100%;
      min-width: 1280px;
      max-width: 1679px;
      height: 40px;
      padding: 0 60px;
      bottom: 0;
      left: 0;
      right: 0;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 20px;
        }
        .left-border {
          padding-left: 20px;
        }
        .footer-phone {
          width: 17px;
          height: 17px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 20px;
        }
        .right-border {
          padding-left: 20px;
        }
        .icp {
          font-size: 14px;
        }
      }
    }

    .light-footer {
      flex: 1;
      // width: 1679px;
      width:auto;
      min-width: 1280px;
      max-width: 1679px;
      height: 40px;
      padding: 0 60px;
      bottom: 0;
      left: 0;
      right: 0;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 20px;
        }
        .left-border {
          padding-left: 20px;
        }
        .footer-phone {
          width: 17px;
          height: 17px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 20px;
        }
        .right-border {
          padding-left: 20px;
        }
        .icp {
          font-size: 14px;
        }
      }
    }
    .custom-footer {
      height: 189px !important;
      width: auto;
      min-width: 1280px;
      max-width: 1679px;
      padding: 0 263.7px;

      .logo {
        width: 171px;
        height: 54px;
        margin-right: 36px;
      }

      .info {
        width: 837px;
        padding-left: 36px;
        .slogan {
          font-size: 16px;
        }
        .phone {
          margin-bottom: 21.6px;
          font-size: 14px;
        }
        .support {
          font-size: 12px;
          margin-bottom: 5.4px;
        }
        .icp {
          font-size: 12px;
        }
      }
      .qrcode {
        width: 99px;
        height: 99px;
      }
    }
  }
}
</style>
